import {AIProvider, AIProviderSettings} from "../AIProvider";
import {CommonSettings} from "../common/CommonSettings";

export const GrokSettings = (props: {
    provider: AIProvider,
    settings: AIProviderSettings,
    onChange: (settings: AIProviderSettings) => void
}) => {
    return (
        <CommonSettings provider={props.provider} settings={props.settings} onChange={props.onChange}/>
    )
}